"use client";

import { Logger, ProxyTransport } from "@axiomhq/logging";
import { createUseLogger, createWebVitalsComponent } from "@axiomhq/react";

/**
 * Browser logs never carry an Axiom token: they post to this first-party
 * proxy path, which `apps/web/app/(public)/api/v2/infra/axiom/route.ts`
 * serves and forwards server-side. The path must stay excluded from the
 * middleware matcher (see apps/web/middleware.ts) or venue custom domains
 * rewrite it to `/venue/[slug]/api/v2/infra/axiom` and every browser event
 * 404s silently.
 */
export const AXIOM_PROXY_PATH = "/api/v2/infra/axiom";

export const logger = new Logger({
  transports: [new ProxyTransport({ url: AXIOM_PROXY_PATH, autoFlush: true })],
});

/** React hook for logging from client components. */
export const useLogger = createUseLogger(logger);

/** Drop into the root layout to stream Core Web Vitals to Axiom. */
export const WebVitals = createWebVitalsComponent(logger);
